import React from 'react';

function TagHeroLoading() {
  return <section className="taghero skeleton" />;
}

export default TagHeroLoading;
